<template>
  <div class="col-md-12">

    <el-dialog center title="Seja Bem Vindo" :visible.sync="modals.centered">
      <div class="col-md-12 text-justify" >
          <p class="text-center" style="white-space: pre-wrap; word-break: keep-all;"> Olá {{$auth.user().name}}! É um prazer ter você como aluno(a) da Academia Top Trader.  </p>
          <p> Vou te mostrar como vai ser seu curso em <strong>5 passos</strong>. Fique atento às intruções a seguir:</p>
          <li style="white-space: pre-wrap; word-break: keep-all;">Para que nossos instrutores e suporte entrem em contato com você é importante que <strong>complete todas as suas informaçoes de cadastro</strong>.
          </li>
          <li style="white-space: pre-wrap; word-break: keep-all;">Veja todos os vídeos em sequência. Deixe seu feedback com a reação do que você achou da aula. Após o termino do vídeo clique em  <strong>"Marcar como Concluido" </strong>para que o próximo vídeo seja liberado. Isto facilita o acompanhamento de seu progresso e nos ajuda a melhorar a plataforma.
          </li>
          <li style="white-space: pre-wrap; word-break: keep-all;"><strong>Após a conclusão de todos os vídeos</strong> você terá acesso aos <strong>Grupos de estudos</strong> conforme as especificações do seu plano.
          </li>
          <li style="white-space: pre-wrap; word-break: keep-all;"><strong>Você terá acesso exclusivo</strong> de ferramentas como Calculadora de Ordens e Catalogação de Velas da teoria Cutrim enquanto seu curso estiver ativo.
          </li>
          <li style="white-space: pre-wrap; word-break: keep-all;"><strong>Fique atento aos nossos avisos</strong> que aparecerão no "sininho" na área superior direita. Caso haja dúvidas, use nossos meios de comunicação clicando no botão de ajuda, ou abrindo um chamado no SAC, você pode encontrar essa e outras opções no menu.
          </li>
          <br>
          <p class="text-center">
          <strong>Pronto, agora você já sabe como navegar pela plataforma.</strong>
          </p>
        <br>
        <div class="text-center">
          <router-link class="btn btn-wd" to="/user" href="/dashboard" >Completar meu Cadastro</router-link>
                    <br><p class="small">
          Para que esta mensagem deixe de aparecer complete seu cadastro.
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog center title="Aviso Importante" :visible.sync="modals.notice">
      <div class="col-md-12 text-center">
        <img style=" width: 100%; height: 100%;" src="static/img/notice/notice.png">
      </div>
    </el-dialog>

    <div >
      Escolha seu tema:
      <l-switch v-model="layout">
        <i class="fa fa-sun" slot="on"></i>
        <i class="fa fa-moon" style="color:black;" slot="off"></i>
      </l-switch>
    </div>

    <div class="row">

      <div class="col-md-3">
        <stats-card :title="'$' + bankroll" subTitle="Banca na Corretora:">
          <div slot="header" >
             <i class="fa fa-donate" :class="' icon-orange-'+theme"></i>
          </div>
          <template slot="footer" >
            <router-link to="/performance" href="/performance" :class="'card-title-'+theme">
              <i class="nc-icon nc-stre-right" :class="'card-title-'+theme"></i>Trading System
            </router-link>
          </template>
        </stats-card>
      </div>

      <div class="col-md-3" >
        <div class="row" v-if="loadingCountWorkshops" v-loading="loadingCountWorkshops" id="loading">
        </div>
        <stats-card v-if="!loadingCountWorkshops" title="Catalogador Automatico" >
            <div slot="header" >
              <i class="fa fa-chart-line icon" :class="'icon-blue-'+theme"></i>
            </div>
            <template slot="footer">
              <router-link target="_blank" type="submit" :class="'card-title-'+theme" :to="{ name: 'Catalogação Teoria Cutrim' }">
                <i class="fa fa-calendar-o"></i>Acesse Já
              </router-link>
            </template>
        </stats-card>
      </div>

      <div class="col-md-3" v-if="$auth.user().conference_room_access || $auth.user().workshop_access">
        <div class="row" v-if="loadingCountConferenceRoom" v-loading="loadingCountConferenceRoom" id="loading"></div>
        <stats-card v-if="!loadingCountConferenceRoom" >
          <div slot="header">
            <i class="fa fa-tachometer-alt icon" :class="'icon-red-'+theme"></i>
          </div>
          <div slot="content">
            <h5 class="mb-2"> <strong>{{countOfWatchedConferenceRoom}}</strong> Grupos de estudos conclúidos</h5>
            <h5 class="mb-2"> <strong>{{countOfWatchedWorkshops}}</strong> Especializações  </h5>
          </div>
          <div slot="footer">
            <i class="fa fa-calendar-o"></i>Assistidas até hoje
          </div>
        </stats-card>
      </div>


      <div class="col-md-3" v-if="$auth.user().conference_room_access">
        <div class="row" v-if="loadingNextConferenceRoom" v-loading="loadingNextConferenceRoom" id="loading"></div>
        <stats-card v-if="!loadingNextConferenceRoom" :title="nextConferenceRoom" subTitle="Próximo grupo de estudo:">
          <div slot="header">
            <i class="fa fa-chalkboard-teacher icon" :class="' icon-green-'+theme"></i>
          </div>
          <template slot="footer">
            <router-link to="/conferenceroom" href="/conferenceroom" :class="'card-title-'+theme">
              <i class="nc-icon nc-stre-right" :class="'card-title-'+theme"></i> Participe!
            </router-link>
          </template>
        </stats-card>
      </div>

    </div><!--cards row-->



    <div class="row">

      <div class="col-md-6 col-sm-12">
        <notice />
      </div>

      <div class="col-md-6 col-sm-12">
        <!-- <card class="d-flex align-self-stretch" :class="'card-'+theme">
          <template slot="header" >
            <h5 class="text-center mb-0">Olá {{ $auth.user().name }}, nos ajude a melhorar ainda mais a sua experiência com a academia. </h5>
            <p class="text-center mb-0">
              <small > Caso já tenha votado não será necessário votar novamente.</small>
            </p>
          </template>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSegJOijoj89o0vSPbr64Ybf_2OuTUQ5DH4iq7BskCWefBg8nw/viewform?embedded=true" width="640" height="581" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
        </card> -->
        <card class="d-flex align-self-stretch" :class="'card-'+theme">
          <template slot="header" >
            <h5 class="text-center mb-0">Olá {{ $auth.user().name }}, <a href="https://everinvestor.com.br/corretora" class="infinox">cadastre-se na XTB.</a> </h5>
          </template>
          <iframe width="100%" height="360px" src="https://vimeo.com/showcase/7380300/embed" frameborder="0" allow="autoplay;fullscreen;encrypted-media" allowfullscreen>
          </iframe>
          <br>
        </card>
      </div>

    </div>

      <div v-if="!forexOnly" class="col-md-12 col-sm-12 px-0">
        <orders-calculator />
      </div>

  </div>
</template>
<script>
import Vue from "vue";
import swal from "sweetalert2";
import { Loading, Dialog} from "element-ui";
import moment from "moment";
import _ from "lodash";
import {
  ChartCard,
  StatsCard,
  Card,
  Switch as LSwitch,
} from "src/components/index";
import carousel from 'vue-owl-carousel'
import videoCard from './../Pages/CardVideos'
import SlidersVideos from './../Pages/SlidersVideos'
import Grafic from './../Pages/Grafic'
import Notice from './../Pages/Notice'
import OrdersCalculator from './../Pages/OrdersCalculator'

Vue.use(Loading.directive);

export default {
  components: {
    [Dialog.name]: Dialog,
    Card,
    ChartCard,
    StatsCard,
    LSwitch,
    carousel,
    videoCard,
    Grafic,
    SlidersVideos,
    OrdersCalculator,
    Notice
  },
  data() {
    return {
      telegram: "",
      timeNow: moment(),
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false,
        notice: false,
        evaluation: false,
        event: false
      },
      bankroll: "",
      weekProfit: "",
      todayProfit: "",
      loadingLearningTrail: false,
      loadingCountConferenceRoom: false,
      loadingCountWorkshops: false,
      loadingLastWeekOrders: false,
      loadingNextConferenceRoom: false,
      countOfWatchedConferenceRoom: 0,
      countOfWatchedWorkshops: 0,
      nextConferenceRoom: "-",
      editTooltip: "Edit Task",
      deleteTooltip: "Remove",
      learningTrail: [],
      layout: true,
      forexOnly: false,
    }
  },
  mounted() {
    this.forexOnly = this.$auth.user().plan_type_code === 'START'
    if (this.$auth.user().layout == "black") {
      this.layout = false;
    } else {
      this.layout = true;
    }
    // this.timeToViewNotice();
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  watch: {
    layout(newValue, oldValue) {
      if (newValue == false) {
        this.$auth.user().layout = "black";
        this.axios
          .put("/students/layouts", {
            layout: "black"
          })
          .catch(error => {
            this.loadingLearningTrail = false;
            console.log(error);
          });
      } else {
        this.$auth.user().layout = "light";
        this.axios
          .put("/students/layouts", {
            layout: "light"
          })
          .catch(error => {
            this.loadingLearningTrail = false;
            console.log(error);
          });
      }
    }
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchCountStudentConferenceRooms() {
      this.loadingCountConferenceRoom = true;
      this.axios
      .get('/countstudentconferencerooms')
      .then(response => {
        this.loadingCountConferenceRoom = false
        if (response.data) {
          this.countOfWatchedConferenceRoom = response.data
        }
      })
      .catch(error => {
        this.loadingCountConferenceRoom = false
        console.log(error)
      })
    },
    fetchCountStudentWorkshops() {
      this.loadingCountWorkshops = true;
      this.axios
      .get('/countstudentworkshops')
      .then(response => {
        this.loadingCountWorkshops = false
        if (response.data) {
          this.countOfWatchedWorkshops = response.data
        }
      })
      .catch(error => {
        this.loadingCountWorkshops = false
        console.log(error)
      })
    },
    fetchUserTodaysConferenceRoomSchedules() {
      this.loadingNextConferenceRoom = true;
      this.axios
      .get('/todaysconferenceroomschedules?include=conferenceRoom')
      .then(response => {
        if (response.data.data[0]) {
          this.nextConferenceRoom = response.data.data[0].conferenceRoom.data.name + ' - ' +
          response.data.data[0].daily_time + 'Hrs'
        }
        this.nextConferenceRoom = response.data.data[0]
        .this.loadingNextConferenceRoom = false
      })
      .catch(error => {
        this.loadingNextConferenceRoom = false
      })
    },
    fetchUserBankroll() {
      this.axios
      .get('/orders/bankroll')
      .then(response => {
        this.bankroll = response.data.order.bankroll
        this.bankroll = Number.parseFloat(this.bankroll + '').toFixed(2)
        this.fetchTodaysOrders()
      }).catch((error) => {
        this.bankroll = 0
      })
    },
    fetchLearningTrail(){
      this.axios.get('/learningtrail')
    },
    fetchTodaysOrders() {
      this.axios
      .get('/orders/today')
      .then(response => {
        let orders = response.data.orders

        if (response.data.orders.length > 0) {
          this.todayProfit = 0
          orders.filter(order => order.kind === 'order')
          .map(order => {
            this.todayProfit += (order.bankroll - order.old_bankroll)
          })
          this.todayProfit = Number.parseFloat(this.todayProfit + '').toFixed(2)
        } else {
          this.todayProfit = 0
        }
      }).catch((error) => {
        this.todayProfit = 0
      })
    },
    /* testModal() {
    //  this.openModal("notice");
       this.modals["notice"] = true
       // console.log(this.timeNow);
    },
    timeToViewNotice() {
      if (this.timeNow.isBefore('2019-08-15', 'day')) {
        this.modals["notice"] = true
      //  this.openModal("notice");
      //  console.log('foi');
      }
      return -1;
      //  this.closeModal("notice");
        this.modals["notice"] = false
       // console.log('não foi');
    }, */
  },
  created () {
   this.fetchCountStudentConferenceRooms()
   this.fetchCountStudentWorkshops()
   this.fetchUserBankroll()
   this.fetchUserTodaysConferenceRoomSchedules()
   this.fetchLearningTrail()
   this.$auth.fetch({
     success: function () {
       if (this.$auth.user().conferenceRoom === 1 ) {
         this.openModal('centered')
       }
     },
     error: function () { }
   })
   // this.openModal('notice')
 }
}
</script>
<style>
/* unvisited link */
a.infinox:link {
  color: #3399FF !important;
}

/* visited link */
a.infinox:visited {
  color: #3399FF !important;
}

/* mouse over link */
a.infinox:hover {
  color: #F5F5F5 !important;
}

/* selected link */
a.infinox:active {
  color: #3399FF !important;
}
.btn-outline {
  border: 1px solid $btn-color !important;
}
.form-check-label{
    padding-left: 10px !important;
    padding-top: 5px !important;
  }
 /* color black */
.icon-red-black {
  color: #ff2a6e;
}
.icon-green-black {
  color: #11d168;
}
.icon-blue-black {
  color: #1bbbdb;
}
.icon-orange-black {
  color: #e7b019;
}
 /* color light */
.icon-red-light {
  color: #f899b7;
}
.icon-green-light {
  color: #81ffba;
}
.icon-blue-light {
  color: #9beeff;
}
.icon-orange-light {
  color: #fcc786;
}
 /* cards dark */
.bg-card-black,
.card-black {
  background-color: #1D2024;
  color: #ffffff !important;
}
.card-catalog-black {
  background-color: #2A2B31;
}
.card-title-black,
.card-category-black
 {
  color: #ffffff !important;
}

/* cards light*/
.card-title-light,
.card-category-light {
  color: #000000 ;
}

#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }
  .el-loading-mask {
    background: transparent !important;
  }
}

@media screen and (max-width: 1200px) {
  #horizontalTimelineBar {
    visibility: hidden;
    display: none;
  }

  #verticalTimelineBar {
    visibility: visible;
    display: block;
  }
}

@media screen and (min-width: 1200px) {
  #horizontalTimelineBar {
    visibility: visible;
    display: block;
  }

  #verticalTimelineBar {
    visibility: visible;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Dashboard/Overview.vue